// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3JV_U","title":"FrontImage_title__2WbDF"};